import { z } from 'zod';
const uuidSchema = z
    .string()
    .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
/** Comment bodies are capped like every other rich-text input (spec §6). */
const commentTextSchema = z.string().trim().min(1).max(2_000);
/** Start a thread: on a text range (`quote`) or on the page as a whole. */
export const createThreadSchema = z.object({
    quote: z.string().trim().min(1).max(2_000).nullable().optional(),
    text: commentTextSchema,
});
export const replySchema = z.object({ text: commentTextSchema });
export const editCommentSchema = z.object({ text: commentTextSchema });
export const resolveThreadSchema = z.object({ resolved: z.boolean() });
export const commentIdSchema = uuidSchema;
//# sourceMappingURL=comments.js.map